import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";
import { decryptToken } from "../../../Services/Account/EncryptionToken";

export const GetAllTasks = createAsyncThunk(
  "Tasks/GetAllTasks",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      let accessToken = await decryptToken("AccessTokenManager", "manager");
      const response = await apiClient.post(
        "api/Tasks/GetAllTasks",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        },
        {
          headers: {
            authorization: "Bearer " + accessToken,
          },
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaaaaaaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetMainTaskById = createAsyncThunk(
  "GetMainTaskById",
  async (taskFlowGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Tasks/GetMainTaskById", {
        taskFlowGUID: taskFlowGUID,
      });

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetSubTaskById");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllTasksToEvalAssigin = createAsyncThunk(
  "GetAllTasksToEvalAssigin",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Tasks/GetAllTasksToEvalAssigin",
        {}
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const TasksManager = createSlice({
  name: "TasksManager",
  initialState: {
    TasksManager: [],
    loadingTasksManager: false,
    errorTasksManager: null,

    //------------------------------------------------------
    TaskbyId: {},
    loadingTaskbyId: false,
    errorTaskbyId: null,

    //-------------------TasksToEvalAssigin-----------------------------------
    TaskEvaluterAssigin: [],
    loadingTaskEvaluterAssigin: false,
    errorTaskEvaluterAssigin: null,
  },
  reducers: {
    SetTasksManager: (state, action) => {
      state.TasksManager = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllTasks.pending, (state, action) => {
        state.loadingTasksManager = true;
        state.TasksManager = action.payload;
        state.errorTasksManager = null;
      })
      .addCase(GetAllTasks.fulfilled, (state, action) => {
        state.loadingTasksManager = false;
        state.TasksManager = action.payload;
      })
      .addCase(GetAllTasks.rejected, (state, action) => {
        state.loadingTasksManager = false;
        state.errorTasksManager = action.payload;
      })

      //----------------------------------------------------------------------------

      .addCase(GetMainTaskById.pending, (state, action) => {
        state.loadingTaskbyId = true;
        state.TaskbyId = action.payload;
        state.errorTaskbyId = null;
      })
      .addCase(GetMainTaskById.fulfilled, (state, action) => {
        state.loadingTaskbyId = false;
        state.TaskbyId = action.payload;
      })
      .addCase(GetMainTaskById.rejected, (state, action) => {
        state.loadingTaskbyId = false;
        state.errorTaskbyId = action.payload;
      })

      .addCase(GetAllTasksToEvalAssigin.pending, (state, action) => {
        state.loadingTaskEvaluterAssigin = true;
        state.TaskEvaluterAssigin = action.payload;
        state.errorTaskEvaluterAssigin = null;
      })
      .addCase(GetAllTasksToEvalAssigin.fulfilled, (state, action) => {
        state.loadingTaskEvaluterAssigin = false;
        state.TaskEvaluterAssigin = action.payload;
      })
      .addCase(GetAllTasksToEvalAssigin.rejected, (state, action) => {
        state.loadingTaskEvaluterAssigin = false;
        state.errorTaskEvaluterAssigin = action.payload;
      });
  },
});

export const { SetTasksManager } = TasksManager.actions;

export default TasksManager.reducer;
